import { snakeToCamel } from "@/utils/utilsGrpcRest";
import { atmoClient } from "@/setup/clients/atmoClient";
import { reportsApi, listAllPages } from "@/api/clients/reportGeneratorSdk";
import { toReportFormPayload } from "@/composables/reportSteppers/reportFormPayload";

// Traduit les filtres historiques (snake_case, hérités des headers gRPC) vers
// les query params typés du SDK.
const toReportsListRequest = (filters = {}) => ({
  serviceId: filters.service_id,
  objectId: filters.object_id,
  template: filters.template ? [filters.template] : undefined,
});

export const ReportClient = {
  list: async (filters) =>
    listAllPages((page) =>
      reportsApi.list({ ...toReportsListRequest(filters), page, pageSize: 100 })
    ),
  fullReportList: async (filters) =>
    listAllPages((page) =>
      reportsApi.list({
        ...toReportsListRequest(filters),
        include: "full",
        page,
        pageSize: 100,
      })
    ),

  create: async (data) => {
    const response = await atmoClient.post("/reports/generate/", {
      project_uuid: data.projectUuid,
      template_uuid: data.templateUuid,
      report_data: data.reportData
        ? toReportFormPayload(data.reportData)
        : null,
      installations: data.installations ?? [],
      recipients: data.recipients ?? [],
      order_form_uuid: data.orderFormUuid ?? null,
      version: data.version ?? 1,
    });
    return response.data;
  },
  destroy: async (reportUuid) => {
    await reportsApi.destroy({ uuid: reportUuid });
  },

  updateStatus: async (uuid, status) => {
    // Transitions de statut (validation/envoi) : PATCH {status} côté RG.
    // Le champ data de la réponse est un JSON brut (snake_case) → camelisé
    // pour conserver le contrat historique du client.
    const response = await reportsApi.partialUpdate({
      uuid,
      patchedReport: { status },
    });
    return snakeToCamel(response.data);
  },
  retrieveReportGenerationData: async (uuid) => {
    const response = await reportsApi.retrieve({ uuid });
    return response.reportGenerationData;
  },

  queryParameterPreviewData: async (dataToDisplayForm) => {
    const response = await atmoClient.post("/reports/preview-parameters/", {
      data_to_display_form: toReportFormPayload(dataToDisplayForm),
    });
    return response.data.result;
  },
};
